import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esFibromyalgia } from "@/pages/es/esConditionData3";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/fibromyalgia-treatment-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esFibromyalgia),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esFibromyalgia} />;
}
